import { MDSText } from '@midwest/web/base';
import { Link } from '@midwest/web/link';
import { textBodyRegDefault } from '@thrivent/midwest-shared';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Subtitle = styled(MDSText.BodyHeavySm)`
  margin-block: 0.75rem 0.5rem;
`;

export const ProductLink = styled(Link)`
  margin-top: 1.25rem;
  font-weight: ${textBodyRegDefault.weight};
`;

export const Disclaimer = styled(MDSText.MiniDefault)`
  margin-top: 2rem;
`;
